// @ts-nocheck
/* Store Custom Code - This file was done like that before adding the toolkit */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import Block from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
import { ProductDetailsAnchorHeadingStyles } from "@store/Library/Widgets/ProductDetails/ProductDetailsAnchorHeading";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";

const AnchorHeading = getWidgetComponent("ProductDetails/ProductDetailsAnchorHeading");
/* Starter Custom Code */

/* Store Custom Code - Start */
import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";
import { attributesCalculation } from "@store/Framework/Common/Utilities/attributesCalculation";
import {
    attributeTypeLabelTextStyles,
    attributeTypeValuesTextStyles,
    attributeValuesTextStyles,
    specificationWrapperStyles,
    specStyles,
    wrapperStyles,
} from "@store/Themes/common/mixins/attributes";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const enum fields {
    /* Store Custom Code - Start */
    showDocuments = "showDocuments",
    showAttributes = "showAttributes",
    attributesPosition = "attributesPosition",
    documentsPosition = "documentsPosition",
    /* Store Custom Code - End */
    /* Starter Custom Code */
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    /* Starter Custom Code */
    // Store Custom Code
    maximumAttributes = "maximumAttributes",
}

/* Starter Custom Code */
type Props = WidgetProps &
    HasProduct & {
        fields: {
            [fields.blockFullWidth]: boolean;
            [fields.blockVariant]: string;
            [fields.blockVariantSide]: string;
            [fields.blockMargin]: string;
        };
    };
/* Starter Custom Code */

export interface ProductDetailsSpecificationsStyles {
    heading?: ProductDetailsAnchorHeadingStyles;
    // Store Custom Code
    specificationsAccordion?: AccordionProps;
    specificationsAccordionSection?: AccordionSectionPresentationProps;
    documentsContainer?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    attributeTypeWrapper?: InjectableCss;
    attributeTypeLabelText?: TypographyPresentationProps;
    attributeTypeValuesText?: TypographyPresentationProps;
    wrapper?: GridItemProps;
    DetailsWrapper?: InjectableCss;
    spec?: TypographyPresentationProps;
    specificationWrapper?: GridContainerProps;
}

export const specificationsStyles: ProductDetailsSpecificationsStyles = {
    // Store Custom Code
    documentGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    documentIcon: {
        src: File,
        color: "text.link",
        css: css`
            margin-right: ${pxToRem(10)};
        `,
    },
    documentNameText: {
        css: css`
            vertical-align: super;
        `,
    },
    attributeTypeLabelText: {
        css: css`
            ${attributeTypeLabelTextStyles()};
        `,
    },
    attributeTypeValuesText: {
        css: css`
            ${attributeValuesTextStyles()};
        `,
    },
    attributeTypeWrapper: {
        css: css`
            ${attributeTypeValuesTextStyles()};
        `,
    },
    wrapper: {
        width: [12, 12, 12, 3, 3],
        css: css`
            ${wrapperStyles()};
        `,
    },
    DetailsWrapper: {
        css: css`
            margin-bottom: ${x => x.theme.design.typography.spacing.base};
        `,
    },
    spec: {
        css: css`
            ${specStyles("", 0)};
        `,
    },
    specificationWrapper: {
        css: css`
            ${specificationWrapperStyles()};
        `,
    },
};

const styles = specificationsStyles;

const ProductDetailsSpecifications: React.FC<Props> = ({
    product: { brand, attributeTypes, documents, specifications, content },
    fields: {
        showDocuments,
        showAttributes,
        documentsPosition,
        attributesPosition,
        /* Starter Custom Code */
        blockFullWidth,
        blockVariant,
        blockVariantSide,
        blockMargin,
        /* Starter Custom Code */
        // Store Custom Code
        maximumAttributes,
    },
}) => {
    const renderingDocuments = showDocuments && documents && documents.length > 0;
    /* Store Custom Code - Start */
    const technicalDocs = documents!.filter(document => document.documentType.toLowerCase() !== "sub");
    const submittalDocs = documents!.filter(document => document.documentType.toLowerCase() === "sub");
    const renderingAttributes = showAttributes && (brand || (attributeTypes && attributeTypes?.length > 0));
    const renderingSpecifications = specifications && specifications.length > 0;
    const documentsFirst = documentsPosition === "first";
    const attributesFirst = attributesPosition === "first";
    const limitedAttributeTypes = (attributeTypes ?? []).slice(0, maximumAttributes);
    /* Store Custom Code - End */

    if (!renderingDocuments && !renderingAttributes && !renderingSpecifications) {
        return null;
    }

    const documentsAccordion = renderingDocuments && (
        /* Starter Custom Code - Start */
        <>
            {technicalDocs.length > 0 && (
                /* Starter Custom Code - End */
                <ManagedAccordionSection
                    /* Starter Custom Code - Start */
                    title={translate("Technical Documents")}
                    /* Starter Custom Code - End */
                    data-test-selector="productDetails_specifications_documents"
                    initialExpanded={
                        ((!attributesFirst || !renderingAttributes) && documentsFirst) ||
                        (!renderingSpecifications && !renderingAttributes)
                    }
                    {...styles.specificationsAccordionSection}
                >
                    <GridContainer {...styles.documentsContainer}>
                        {/* Starter Custom Code - Start */}
                        {technicalDocs.map(document => (
                            /* Starter Custom Code - End */
                            <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                                <Link
                                    href={document.filePath}
                                    target="_new"
                                    {...styles.documentLink}
                                    data-test-selector={`productDetails_${document.id}`}
                                >
                                    <IconMemo {...styles.documentIcon} />
                                    <Typography {...styles.documentNameText}>{document.name}</Typography>
                                </Link>
                            </GridItem>
                        ))}
                    </GridContainer>
                </ManagedAccordionSection>
                /* Starter Custom Code - Start */
            )}
            {submittalDocs.length > 0 && (
                <ManagedAccordionSection
                    title={translate("Submittal Documents")}
                    data-test-selector="productDetails_submittal_documents"
                    initialExpanded={
                        ((!attributesFirst || !renderingAttributes) && documentsFirst) ||
                        (!renderingSpecifications && !renderingAttributes)
                    }
                    {...styles.specificationsAccordionSection}
                >
                    <GridContainer {...styles.documentsContainer}>
                        {submittalDocs.map(document => (
                            <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                                <Link
                                    href={document.filePath}
                                    target="_new"
                                    {...styles.documentLink}
                                    data-test-selector={`productDetails_${document.id}`}
                                >
                                    <IconMemo {...styles.documentIcon} />
                                    <Typography {...styles.documentNameText}>{document.name}</Typography>
                                </Link>
                            </GridItem>
                        ))}
                    </GridContainer>
                </ManagedAccordionSection>
            )}
        </>
        /* Starter Custom Code - End */
    );

    /* Starter Custom Code - Start */
    const TempArray = attributesCalculation(limitedAttributeTypes);
    /* Starter Custom Code - End */

    const attributesAccordion = renderingAttributes && (
        <ManagedAccordionSection
            /* Starter Custom Code - Start */
            title={translate("Full Description")}
            /* Starter Custom Code - End */
            initialExpanded={attributesFirst || (!renderingSpecifications && !renderingDocuments)}
            data-test-selector="productDetails_specifications_attributes"
            {...styles.specificationsAccordionSection}
        >
            {/* Starter Removed Code  */}
            {content && (
                <StyledWrapper {...styles.DetailsWrapper}>
                    <div data-test-selector="productDetails_htmlContent">
                        {parse(content.htmlContent, parserOptions)}
                    </div>
                </StyledWrapper>
            )}
            <StyledWrapper>
                <Typography as="p" {...styles.spec}>
                    {translate("Specifications")}
                </Typography>
                {/* Starter Custom Code - Start */}
                <GridContainer {...styles.specificationWrapper}>
                    {TempArray &&
                        TempArray.map((attributeArray: AttributeTypeModel[]) => (
                            <GridItem {...styles.wrapper} key={attributeArray.length.toString()}>
                                {attributeArray.map(attributeType => (
                                    <>
                                        <StyledWrapper
                                            {...styles.attributeTypeWrapper}
                                            key={attributeType.id.toString()}
                                        >
                                            <Typography {...styles.attributeTypeLabelText}>
                                                {attributeType.label || attributeType.name}:
                                            </Typography>
                                            <Typography {...styles.attributeTypeValuesText}>
                                                {attributeType
                                                    .attributeValues!.map(
                                                        (attributeValue: { valueDisplay: any }) =>
                                                            attributeValue.valueDisplay,
                                                    )
                                                    .join(", ")}
                                            </Typography>
                                        </StyledWrapper>
                                    </>
                                ))}
                            </GridItem>
                        ))}
                </GridContainer>
                {/* Starter Custom Code - End */}
            </StyledWrapper>
        </ManagedAccordionSection>
    );

    return (
        <Accordion
            headingLevel={2}
            data-test-selector="productDetails_specifications"
            {...styles.specificationsAccordion}
        >
            {attributesFirst && attributesAccordion}
            {documentsFirst && documentsAccordion}
            {renderingSpecifications &&
                specifications?.map((specification, index) => (
                    // Starter Removed Code
                    <ManagedAccordionSection
                        initialExpanded={
                            index === 0 &&
                            (!documentsFirst || !renderingDocuments) &&
                            (!attributesFirst || !renderingAttributes)
                        }
                        key={specification.id.toString()}
                        title={specification.nameDisplay}
                        data-test-selector="productDetails_specifications_specification"
                        {...styles.specificationsAccordionSection}
                    >
                        {parse(transformContentHtml(specification.htmlContent), parserOptions)}
                    </ManagedAccordionSection>
                ))}
            {!attributesFirst && attributesAccordion}
            {!documentsFirst && documentsAccordion}
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsSpecifications),
    definition: {
        displayName: "Specification",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showDocuments,
                displayName: "Show Documents",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.documentsPosition,
                displayName: "Documents Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                fieldType: "General",
                sortOrder: 2,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showDocuments,
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.attributesPosition,
                displayName: "Attributes Position",
                editorTemplate: "RadioButtonsField",
                defaultValue: "first",
                fieldType: "General",
                sortOrder: 4,
                options: [
                    {
                        displayName: "Display First",
                        value: "first",
                    },
                    {
                        displayName: "Display Last",
                        value: "last",
                    },
                ],
                isVisible: widget => widget.fields.showAttributes,
            },
            /* Starter Custom Code */
            {
                ...blockVariantField,
                name: fields.blockVariant,
                sortOrder: 100,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                sortOrder: 101,
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                sortOrder: 103,
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                sortOrder: 104,
            },
            /* Starter Custom Code */
            /* Store Custom Code - Start */
            {
                name: fields.maximumAttributes,
                displayName: "Maximum attributes to display",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                tooltip: "integer value",
                isRequired: true,
            },
            /* Store Custom Code - End */
        ],
    },
};

export default widgetModule;
